import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { log, LoggingDomain } from '@/Logging';
import { getU2fRelyingPartyId } from '@/Constants/U2FConstants';
import { startAuthentication } from '@simplewebauthn/browser';
import { useCallback, useState } from 'react';
import { c } from 'ttag';
import Button from '../Button/Button';
const U2FPromptFirefoxNative = ({ contextData, onResponse, apiHost, buttonRef }) => {
    const [pending, setPending] = useState(false);
    const [error, setError] = useState('');
    const authenticateWithSecurityKey = useCallback(async () => {
        var _a;
        const username = contextData === null || contextData === void 0 ? void 0 : contextData.username;
        if (!username) {
            setError(c('B1.Account.SignIn.Error').t `No username provided`);
            return;
        }
        setPending(true);
        setError('');
        try {
            const response = await fetch(`${apiHost}/v1/authenticators/generate-authentication-options`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username }),
            });
            const jsonResponse = await response.json();
            if (!((_a = jsonResponse.data) === null || _a === void 0 ? void 0 : _a.options)) {
                throw new Error(c('B1.Account.SignIn.Error').t `No options returned from server`);
            }
            const options = jsonResponse.data.options;
            const rpId = getU2fRelyingPartyId(apiHost, options);
            log(LoggingDomain.U2F, 'Starting native WebAuthn authentication', {
                username,
                apiHost,
                rpId,
            });
            const assertionResponse = await startAuthentication({
                ...options,
                rpId,
            });
            log(LoggingDomain.U2F, 'Native WebAuthn authentication completed', { id: assertionResponse.id });
            onResponse(assertionResponse);
        }
        catch (authError) {
            setError(authError instanceof Error ? authError.message : String(authError));
            console.error(authError);
        }
        finally {
            setPending(false);
        }
    }, [contextData, apiHost, onResponse]);
    return (_jsxs("div", { className: "min-w-76", children: [error && _jsx("div", { className: "text-danger", children: error }), _jsx(Button, { primary: true, fullWidth: true, onClick: authenticateWithSecurityKey, disabled: pending, ref: buttonRef, children: pending
                    ? c('B1.Account.SignIn.Status').t `Waiting for security key...`
                    : c('B5.SecuritySync.Challenge.Action').t `Authenticate Device` })] }));
};
export default U2FPromptFirefoxNative;
